"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicIP = void 0;
var REGEX_IP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
var getPublicIP = function getPublicIP(urls) {
  return new Promise(function (resolve) {
    var config = {
      iceServers: [{
        urls: "stun:".concat(urls)
      }]
    };
    var pc = new RTCPeerConnection(config);
    // 监听 ICE 收集状态
    pc.onicegatheringstatechange = function () {
      if (pc.iceGatheringState !== 'complete') {
        return;
      }
      pc.close();
    };
    pc.onicecandidate = function (event) {
      if (event.candidate) {
        var candidate = event.candidate.candidate;
        if (candidate.indexOf('srflx') !== -1) {
          var _REGEX_IP$exec;
          var ip = (_REGEX_IP$exec = REGEX_IP.exec(candidate)) === null || _REGEX_IP$exec === void 0 ? void 0 : _REGEX_IP$exec[0];
          resolve(ip);
        }
      }
    };
    pc.createDataChannel('');
    pc.createOffer().then(function (offer) {
      return pc.setLocalDescription(offer);
    });
  });
};
exports.getPublicIP = getPublicIP;